module.exports = __webpack_public_path__ + "059c91e4e23ecae612d6e99eaf0e56a6.pdf";